/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Paper, Input } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: '4px',
    alignItems: 'center',
    padding: theme.spacing(1),
    display: 'flex',
    flexBasis: 420,
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  input: {
    flexGrow: 1,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '-0.05px',
  },
}));

// COMPONENT
function SearchInput(props, ref) {
  const { classes, cx } = useStyles();

  const { className, onChange, style, ...rest } = props;

  return (
    <Paper {...rest} className={cx(classes.root, className)} style={style}>
      <SearchIcon className={classes.icon} />
      <Input
        {...rest}
        className={classes.input}
        inputRef={ref}
        disableUnderline
        onChange={(e) => onChange(e.target.value)}
      />
    </Paper>
  );
}

export default React.forwardRef(SearchInput);
